<script>
  import SpinnerWithText from 'root/components/molecules/SpinnerWithText.svelte';
  import Module from './AccountManageCompaniesModule';
  import {getLogoFromUserAccount} from 'root/services/tools';
  import RbDropdownActions from 'rfp/rfp-manager/main/pages/components/RfpManagerDropdownActions.svelte';
  import listUsersService from 'vRoot/account-profile/modules/manage-users/services/account-manage-users-list.service';
  import CompanyRow from './CompanyRow.svelte'
  import Logo from './AccountManageCompaniesLogo.svelte';
  import manageCompaniesService from 'vRoot/account-profile/modules/manage-companies/services/manage-company.service';
  import {orderBy} from 'lodash';
  import {PAGE_RFP_MANAGER_COMPANY_PROFILE} from 'root/states';

  export let userAccount, isAdmin, state;

  const sortOptions = [
    {
      id: 'nameDesc',
      label: 'Name A-Z',
      order: 'asc',
      key: 'name'
    },
    {
      id: 'nameAsc',
      label: 'Name Z-A',
      order: 'desc',
      key: 'name'
    }
  ];

  let
    loading = true,
    accounts = [],
    sortedAccounts = [],
    sort = sortOptions[0],
    scrollContainerElement,
    isFromRfpManager = false;

  $: onInit(userAccount);
  $: sortedAccounts = sortAccounts(accounts, userAccount, sort);
  $: isFromRfpManager = state === PAGE_RFP_MANAGER_COMPANY_PROFILE;

  async function onInit(ua){
    if(!ua) return;
    await refreshCompanies();
  }


  function openRfpManager(){
    manageCompaniesService.openRfpManager();
  }

  function openUsersAndPermissions(){
    manageCompaniesService.openUsersAndPermissions();
  }

  function createCompany(){
    manageCompaniesService.createCompany(accounts, state).then(refreshCompanies)
  }

  async function refreshCompanies(){
    loading = true;
    const httpResponse = await listUsersService.listAccounts();
    accounts = httpResponse.data;
    loading = false;
  }

  function sortAccounts(acc, ua, srt){
    if(!acc || !acc.length || !ua || !srt) return [];
    const userAccountAccountId = ua.accountId;
    const filtered = acc.filter(a => a.id !== userAccountAccountId);
    return orderBy(filtered, [srt.key], [srt.order]);
  }

</script>


<div class="AccountManageCompanies">
  {#if loading}
    <div class="layout-column flex-center Loader">
      <SpinnerWithText text="Loading, please wait..." />
    </div>
  {:else}
    <div class="Header">
      <div class="Flex-Row">

        <Logo logo="{getLogoFromUserAccount(userAccount)}" />

        <div class="flex column">
          <div class="Title">
            { userAccount && userAccount.account.name || '' }
          </div>
          <div class="SubTitle">
            { Module.title }
          </div>
        </div>
      </div>

      <div class="Flex-Row Space-Between">
        <div>
          <RbDropdownActions items="{sortOptions}"
                             on:input={ev => {sort = ev.detail}}
                             mode="Light"
                             valueIcon="sort"
          >
            <div slot="value">Sort By: <b>{sort.label}</b></div>
          </RbDropdownActions>
        </div>

        <div class="Flex-Row">
          {#if isFromRfpManager}
            <button class="ActionButton"
                    data-icon-before="arrow_back"
                    on:click="{openRfpManager}">
              Back to RFP Manager
            </button>

            <button class="ActionButton"
                    data-icon-before="people"
                    on:click="{openUsersAndPermissions}">
              Users &amp; Permissions
            </button>
          {/if}

          {#if isAdmin}
            <button class="ActionButton Create"
                    data-icon-before="playlist_add"
                    on:click="{createCompany}">
              Add New Company
            </button>
          {/if}
        </div>
      </div>
    </div>
    <div class="List" bind:this={scrollContainerElement}>
      {#each sortedAccounts as account (account.id)}
        <CompanyRow
          {state}
          {account}
          {userAccount}
          {isAdmin}
          {refreshCompanies}
          {scrollContainerElement}
        />
      {/each}
    </div>
  {/if}
</div>

<style lang="stylus">

  .AccountManageCompanies {
    color: #37474f;
    height: 100%;
    max-height: calc(100vh - 100px);
    overflow: auto;
    display: flex;
    flex-direction: column;
  }

  .Loader {
    height: 100%;
  }

  .Header {
    padding: 20px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: #FFFFFF;
    flex: 0 0 auto;
  }

  .Flex-Row {
    display: flex;
    align-items: center;
    gap: 3px;

    &.Space-Between {
      justify-content: space-between
    }
  }

  .Title {
    font-size: 12px;
    color: #8c999f;
  }

  .SubTitle {
    font-size 20px;
  }

  .List {
    overflow: auto;
    flex: 1 1 100%;
  }

  .ActionButton {
    background white linear-gradient(0deg, #f5f6f7 10%, white 11.05%, white 100%);
    height: 27px;
    box-sizing: border-box;
    font-size: 12px;
    padding: 0 7px;
    border-radius: 2px;
    white-space: nowrap;
    line-height: 16px;
    display: flex;

    &:before {
      height: 16px;
      font-size: 16px;
      margin-right: 5px;
    }

    &.Create {
      background #00b8ab linear-gradient(0deg, #00b0a3 10%, #00b8ab 11.05%, #00b8ab 100%)
      color: #fff;
      border: 1px solid #00b8a9;
    }
  }
</style>
